/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { getUnresolvedTimeAxesLayout } from '#PRIVATE_TimeComponent/utils/timeAxisLayoutUtils';

/**
 * Gets the pan zoom canvas layout given the time axes layout.
 * @param timeAxesLayout The time axes layout.
 * @returns The pan zoom canvas layout.
 */
const getPanZoomCanvasLayout = (timeAxesLayout: ReturnType<typeof getUnresolvedTimeAxesLayout>) => {
  const layout = {
    top: {
      overlayControlsPosition: 'topEnd' as const,
      verticalControlTopGap: timeAxesLayout.height,
      verticalControlBottomGap: '0'
    },
    bottom: {
      overlayControlsPosition: 'bottomEnd' as const,
      verticalControlTopGap: '0',
      verticalControlBottomGap: timeAxesLayout.height
    }
  };
  return layout[timeAxesLayout.position];
};

export { getPanZoomCanvasLayout };
